module.exports = __webpack_public_path__ + "4f9cf7dafc68a47d807099d5152bf6dc.svg";